module.exports = __webpack_public_path__ + "img/sale.47855be9.png";